import React from 'react';
import PropTypes from 'prop-types';

function Infographic(props) {
  const { item } = props;
  return (
    <main className="shadow-md rounded-md">
      <img
        src={item.content.imageUrl}
        alt="infographic"
        className="w-full rounded-md object-contain mx-auto"
        style={{ maxHeight: 'calc(85vh - 110px)' }}
      />
    </main>
  );
}

Infographic.propTypes = {
  item: PropTypes.objectOf({
    content: PropTypes.objectOf({
      imageUrl: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default Infographic;
